import Splide from '@splidejs/splide';

(function () {
  'use strict';

  const selectors = {
    splide: '.js-carousel'
  };

  const init = () => {
    const splides = document.querySelectorAll(selectors.splide);
    splides.forEach((splide) => {
      if (splide instanceof HTMLElement) {
        const carouselInstance = new Splide(selectors.splide, {
          type   : 'loop',
          perPage: 3,
          perMove: 1,
          /*autoplay: false,
          rewind: true,
          perPage: 1,
          interval: 6000,
          speed: 2000,
          width: 'auto',
          height: 'auto',*/
          arrows: false,
          pagination: false
        });

        carouselInstance.mount();

        // External arrow binding
        document.querySelector('.carousel-arrow--prev').addEventListener('click', () => {
          carouselInstance.go('<');
        });

        document.querySelector('.carousel-arrow--next').addEventListener('click', () => {
          carouselInstance.go('>');
        });
      }
    });
  };

  window.addEventListener('load', init);
})();
